<template>
    <IframeWindow v-show="show" :iframe-src="src" :width="326" :height="300"
        :style="{ top: top + 'px', left: left + 'px' }">
        <svg ref="hitArea" class="move" :style="{ transform: 'scale(' + scale + ')' }">
            <g fill="blue" fill-opacity="0">
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="286" height="42" x="0" y="0"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="326" height="72" x="0" y="42"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="34" height="30" x="0" y="114"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="26" height="30" x="102" y="114"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="21" height="30" x="197" y="114"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="38" height="30" x="288" y="114"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="326" height="8" x="0" y="144"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="326" height="24" x="0" y="275"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="10" height="123" x="0" y="152"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea)" width="10" height="123" x="316" y="152"></rect>
            </g>
        </svg>
    </IframeWindow>
</template>

<script>
import IframeWindow from './IframeWindow.vue';
import BookData from '../../js/book_data';
import EventBus from "../../js/event_bus";
import DragElem from '../DragElem.vue';
import { store } from '../../store';
import { VIEW_TYPE } from '../../js/view_type';
export default {
    name: "Stopwatch",
    data: function () {
        return {
            show: false,
            src: "",
            scale: 1,
            layaScale: 1
        }
    },
    components: {
        IframeWindow
    },
    mixins: [
        DragElem
    ],
    mounted() {
        const self = this;

        EventBus.getInstance().emitter.on("stopwatch", function () {
            self.show = true;
            switch (store.nowView) {
                case VIEW_TYPE.ANDROID:
                    self.src = "file:///android_asset/item/stopwatch/index.html";
                    break;
                case VIEW_TYPE.IOS:
                    self.src = "../item/stopwatch/index.html";
                    break;
                default:
                    self.src = BookData.Instance.getItemPath() + "stopwatch/index.html";
                    break;
            }
        })

        window.addEventListener("message", this.receiveMessage, false);
    },
    methods: {
        receiveMessage(event) {
            const message = event.data.message;
            switch (message) {
                case "closeStopwatch":
                    this.show = false;
                    break;
                case "layaCanvasTransform":
                    this.layaScale = parseFloat(event.data.value.split("matrix(")[1].split(",")[0]);
                    console.log("scale:", this.layaScale);
                    this.scale = this.layaScale;
                    break;
            }
        }

    }
}
</script>

<style scoped>
.move {
    position: absolute;
    width: 326px;
    height: 300px;
    top: 0px;
    left: 0px;
    pointer-events: none;
    /* cursor: move; */
}

.moveable {
    pointer-events: fill;
    cursor: move;
}
</style>